import React from "react";
import { Routes as RoutedComponent } from "../routes/Index";

/**
 * Responsible for rendering the component as per route path
 */
const Layout: React.FC<{}> = () => {
    return (
        <div>
            <RoutedComponent />
        </div>
    );
};

export default Layout;
